import { useTranslation } from 'libs/i18n';
import { Section } from 'modules/client/common/components';

import { FormContent, FormContentProps } from './FormContent';

interface Props extends FormContentProps {}

export const FinancialPositionSection = ({ ...formProps }: Props) => {
  const { t } = useTranslation();

  return (
    <Section
      datax="financialPositionSection"
      title={t('client.client.financialPosition.title')}
    >
      <FormContent {...formProps} />
    </Section>
  );
};
